import { Alert } from '@mui/material'

import PageShell from '/components/statistics/page-shell'
import FilterBar from '/components/statistics/filter-bar'
import ChartPanel from '/components/statistics/chart-panel'
import useClientStatistics from '/components/statistics/use-client-statistics'

const activityChartSetting = {
  yAxis: [{ label: 'activity count', width: 90 }]
}

const StatisticsPassActivity = () => {
  const { loading, periodDays, setPeriodDays, selectableTemplates, statistics, templateId, setTemplateId } = useClientStatistics()

  return (
    <PageShell title="Statistics Pass Activity" heading="Statistics - Pass Activity">
      <div className='flex flex-col gap-5 mt-5 pb-20'>
        <FilterBar
          periodDays={periodDays}
          setPeriodDays={setPeriodDays}
          templateId={templateId}
          setTemplateId={setTemplateId}
          selectableTemplates={selectableTemplates}
          summaryItems={[
            { title: 'Issued', value: statistics.totals.issued },
            { title: 'Updated', value: statistics.totals.updated },
            { title: 'Notified', value: statistics.totals.notified }
          ]}
        />

        {!loading && statistics.trend.length === 0 && (
          <Alert severity='info'>No live pass activity was found for the selected period.</Alert>
        )}

        <ChartPanel
          title='Live pass activity trends'
          description='This chart shows live pass issues, updates and notifications over time.'
          dataset={statistics.trend}
          xAxis={{ scaleType: 'band', dataKey: 'bucket_label' }}
          series={[
            { dataKey: 'issued', label: 'Issued' },
            { dataKey: 'updated', label: 'Updated' },
            { dataKey: 'notified', label: 'Notified' }
          ]}
          loading={loading}
          height={420}
          yAxis={activityChartSetting.yAxis}
        />
      </div>
    </PageShell>
  )
}

export default StatisticsPassActivity
